import {
  SurfaceTreatmentMethodSchema,
  SurfaceTreatmentMethodType,
  SurfaceTreatmentTypeType,
} from "shared";

import type { TFunction } from "i18next";

export const getSurfaceTreatmentMethodLabel = (
  t: TFunction,
  method: SurfaceTreatmentMethodType,
): string => t(`settings.surfaceTreatments.methodLabels.${method}`);

export const getSurfaceTreatmentTypeLabel = (
  t: TFunction,
  type: SurfaceTreatmentTypeType,
): string => t(`settings.surfaceTreatments.typeLabels.${type}`);

export const getSurfaceTreatmentPriceSuffix = (
  t: TFunction,
  method: SurfaceTreatmentMethodType,
): string => t(`settings.surfaceTreatments.priceSuffix.${method}`);

export const surfaceTreatmentMethodOptions = (t: TFunction) =>
  Object.values(SurfaceTreatmentMethodSchema.enum).map((method) => ({
    label: getSurfaceTreatmentMethodLabel(t, method),
    value: method,
  }));

export const surfaceTreatmentTypeOptions = (t: TFunction) =>
  (["INHOUSE", "OUTSOURCING"] as const).map((type) => ({
    label: getSurfaceTreatmentTypeLabel(t, type),
    value: type,
  }));
